export default function About() {

  const init = () => {
    initTimeline();
  }

  const initTimeline = () => {
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: reduce)", () => {
      // Sem animação: garante estados finais “acessíveis”
      gsap.set(".card-timeline", {"--progressLine": 1});
      gsap.set(".card-timeline__wrap", {yPercent: 0, autoAlpha: 1});
      gsap.set(".card-timeline__dot", {backgroundColor: "var(--primary-500)"});
      return () => {};
    });

    mm.add("(prefers-reduced-motion: no-preference)", () => {
      const cards = gsap.utils.toArray(".card-timeline");

      // quickSetter: escreve direto na CSS var sem criar tween
      const setProgressVar = el => gsap.quickSetter(el, "--progressLine", 0);

      cards.forEach(card => {
        const elmContent = card.querySelector(".card-timeline__wrap");
        const elmDot     = card.querySelector(".card-timeline__dot");
        if (!elmContent || !elmDot) return;

        const setVar = setProgressVar(card);
        ScrollTrigger.create({
          trigger: card,
          start: "top center",
          end: "bottom center",
          scrub: true,
          onUpdate: self => setVar(self.progress)
          // markers: true,
        });

        const tl = gsap.timeline({ defaults: { ease: "power2.out" } })
          .fromTo(
            elmContent,
            { y: 50, opacity: 0 },
            { y: 0, opacity: 1, duration: 0.7, force3D: true }
          )
          .fromTo(
            elmDot,
            { backgroundColor: "var(--gray-200)" },
            { backgroundColor: "var(--primary-500)", duration: 0.2 },
            "<"
          );

        ScrollTrigger.create({
          trigger: elmDot,
          start: "center center",
          end: "center center",
          toggleActions: "restart none reverse none",
          // markers: { startColor: "purple", endColor: "blue", indent: 200 },
          animation: tl
        });
      });

      // cleanup
      return () => ScrollTrigger.getAll().forEach(st => st.kill());
    });

  };

  init();
}
